/**
 * Theme Requirements Aggregation for Lineups Inc
 * 
 * Extends the base vibeoff-base theme requirements with Lineups Inc specific
 * component requirements.
 */

import type { ComponentRequirements } from '@vibesites/tokens';
import { componentRequirements as baseRequirements } from '@vibesites/theme-vibeoff-base/requirements';

/**
 * Lineups Inc component requirement overrides.
 * Add requirements for any override components here.
 */
const lineupsincOverrides: Record<string, ComponentRequirements> = {
  // Example:
  // Footer: FooterRequirements,
};

/**
 * All component requirements for the Lineups Inc theme.
 * Inherits from vibeoff-base theme and overrides with Lineups Inc components.
 */
export const componentRequirements: Record<string, ComponentRequirements> = {
  ...baseRequirements,
  ...lineupsincOverrides,
};

/**
 * Get requirements for a specific component.
 */
export function getComponentRequirements(componentName: string): ComponentRequirements | undefined {
  return componentRequirements[componentName];
}

/**
 * Get all component names that have requirements defined.
 */
export function getRegisteredComponentNames(): string[] {
  return Object.keys(componentRequirements);
}
